import r from "./_tagTester.js";
import { isIE11 as t } from "./_stringTagBug.js";
import { ie11fingerprint as o, mapMethods as a } from "./_methodFingerprint.js";
var i = t ? o(a) : r("Map");
export { i as default };